import _ from 'lodash';

export const findContacts = (contacts, emailAddresses = [], emailToExclude) =>
  emailAddresses.reduce((acc, email) => {
    if (email !== emailToExclude) {
      const foundContact = contacts.find(({ value }) => _.toLower(value) === email);

      if (foundContact) {
        acc.push(foundContact);
      }
    }

    return acc;
  }, []);
